import React from 'react';
import './StatsGrid.css';
import { formatCount, formatHoursValue, formatMoney } from '../utils/adminFormatters';

const StatsGrid = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="stats-section">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Загрузка финансовой сводки...</p>
        </div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="stats-section">
        <div className="empty-message">Не удалось загрузить финансовые показатели.</div>
      </div>
    );
  }

  const cards = [
    {
      label: 'Выручка',
      value: formatMoney(stats.revenue?.rub, 'RUB'),
      meta: `Средний чек: ${formatMoney(stats.revenue?.averageCheckRub, 'RUB')}`
    },
    {
      label: 'Приобритенные и непотраченные часы',
      value: formatHoursValue(stats.liabilities?.paidHoursLeft),
      meta: `Средний чек: ${formatMoney(stats.revenue?.averageCheckRub, 'RUB')}`
    },
    {
      label: 'Расходы на генерации',
      value: formatMoney(stats.generationExpenses?.rub, 'RUB'),
      meta: `${formatMoney(stats.generationExpenses?.usd, 'USD')} · среднее ${formatMoney(stats.generationExpenses?.averageRub, 'RUB')}`
    },
    {
      label: 'Валовая прибыль',
      value: formatMoney(stats.grossProfitRub, 'RUB'),
      meta: 'Выручка минус расходы на успешные генерации'
    },
    {
      label: 'Транзакции',
      value: formatCount(stats.transactions?.total),
      meta: `Успешно: ${formatCount(stats.transactions?.succeeded)} · Ожидают: ${formatCount(stats.transactions?.waitingForCapture)} · Отменены: ${formatCount(stats.transactions?.canceled)}`
    },
    {
      label: 'Все генерации',
      value: formatCount(stats.generationExpenses?.total),
      meta: `Успешно: ${formatCount(stats.generationExpenses?.successful)} · Ошибки: ${formatCount(stats.generationExpenses?.failed)}`
    }
  ];

  return (
    <div className="stats-section">
      <div className="stats-header">
        <h2>Финансы</h2>
        <div className="stats-caption">Глобальная сводка по YooKassa и user generations</div>
      </div>

      <div className="stats-grid">
        {cards.map((card) => (
          <div key={card.label} className="stat-card">
            <div className="stat-header-content">
              <h3>{card.label}</h3>
            </div>
            <div className="stat-value">{card.value}</div>
            <div className="stat-meta">{card.meta}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsGrid;
